<template>
<div id="FullCarView">  
  <v-card-text>
    <v-container>
      <v-row>
        <v-col cols="12" >
          <h5>
            <b> {{title}}</b>
          </h5>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">                                                                                
          <!-- vertical-delimiters="right" -->
          <v-carousel
            direction="vertical"
            height="400"                                                                                                
          >
                                                <v-carousel-item                                                  
                                                  v-for="fullcarpicture in productInfo.fullcarpictures" :key="fullcarpicture.id"
                                                  v-bind:src="fullcarpicture.filename"
                                                  cover
                                                ></v-carousel-item>                                                
          </v-carousel>
          <br>
          <div style="font-size: 2rem; font-weight: bold;">{{productInfo.price | currency }} </div>                                          

        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6">     
          <img src="" id="barcodeView" alt="" />
          <br>  
          <b>Chasis: </b>{{productInfo.id}} <br>
          <b>Modelo: </b>{{productInfo.model_name}} <br>
          <b>Version: </b>{{productInfo.version_name}} <br>
          <b>Marca: </b>{{productInfo.brand_name}}  <br>
          <b>Transmision: </b>{{productInfo.transmision}} <br>
          <b>Color: </b>{{productInfo.color_ext}} <br>
          <b>Año: </b>{{productInfo.year}} <br>
          <b>Km: </b>{{productInfo.km}}
          <br><br>
          <h6>PLUGINS</h6>
          <b>WOO ID:</b> {{productInfo.woo_id }}
        
        </v-col>             
    </v-row>
    <v-row >
                                  <v-col cols="12" class="my-4">
                                  <!-- Botones Acciones -->
                                  <v-btn-toggle
                                          v-model="toggle_exclusive"
                                          mandatory
                                        >
                                  <v-btn
                                                  v-if='productInfo.woo_url != null'
                                                  color="deep-white default"
                                                  v-bind:href="productInfo.woo_url"
                                                  target="_blank"
                                                >                
                                                <v-icon>public</v-icon>
                                              </v-btn>   

                                              <!-- <v-btn
                                                  color="deep-black"
                                                  v-bind:href="url(productInfo.id)"
                                                  target="_blank"
                                                  >                
                                                  <v-icon>view_list</v-icon>
                                                </v-btn> -->
                                      </v-btn-toggle>                                                                                                                                
                                <!-- FIN Botones Acciones -->
                                  </v-col>
                                  <v-col cols="12" justify="end">
                                    <hr>
                                    <small><b>Registro: </b> {{productInfo.created_at}} </small><br>
                                    <small><b>Actualización: </b> {{productInfo.updated_at}}</small>    
                                  </v-col>
                               </v-row>
                                
                            </v-container>
                          </v-card-text>
  
</div>
</template>

<script>
import{ mapMutations,mapState } from "vuex";
import icheckApi from '@/services/icheckApi';
import JsBarcode from 'jsbarcode';
// import router from '@/router';

export default {
  name: 'FullCarView',  
  components: {
    // BarcodeGenerator
  },  
  computed:{
    // 'products',
    ...mapState(['']) 
  },
  methods:{
    ...mapMutations(["showLoading","hiddenLoading"]),
    async getPrice2(){     
    },
    url: function (href){
        return 'detalleventasproducto?pricelistid='+ href;
    },    
    getDataFullCar(pricelistID) {
        // alert(pricelistID)
          try{        
            this.showLoading({titulo:"Accediendo información del Cliente",color:"warning"})
            icheckApi().get(`/autos/consulta/${pricelistID}`).then((response)=>{
              if(!response.data.error){                
                this.productInfo=response.data;
                this.title=response.data.brand_name;
                // console.log('title '+this.title);
                JsBarcode("#barcodeView", response.data.id, {
                  // format: "pharmacode",
                  // lineColor: "#0aa",
                  width: 2,
                  height: 40,
                  displayValue: false
                });                      
                //this.$swal("Genial!",response.data.message, "success");
                // this.dialog10=true;
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                  
              //console.log("VENTA: "+response.data.message);
            });
          }catch(error){
            // console.log(error);
            this.$swal("Error!", "Algo salio mal, Intente nuevamente <br/>"+error, "error");
          }finally{
            this.hiddenLoading()
          } 

      
      },
  },
  props: {
    // productInfo:{
    //   type:Object,
    //   required:true
    // },
    productid: Number,
  },
  data(){
     return{
        // valid: false,
        // ...validations,
        toggle_exclusive:'',
        attribute: {sword: 'All',limit: 27},
        title:'',
        productInfo:{},
        
      
        
     }
  },
  destroyed() {
    console.log("Componente eliminado FullCarView");
  },
  mounted(){
    console.log("Montado Product View");
    console.log("AutoID "+this.productid);
    if (this.productid>0) {
      this.getDataFullCar(this.productid)
    }
  },
  created(){
    // this.getPrice2()    
  }  
}
</script>